import { dateService } from 'services/DateService';
import { HourlyRentalInfo } from 'types/vehicle.type';

export function usePriceWidgetIsSpecialDate(rentalInfo: HourlyRentalInfo) {
  const getIsSpecialDate = (date: Date) => {
    return rentalInfo.specialDayFactors?.some((sp) => {
      const specialDate = dateService.formatServerDateToLocalDate(sp.date);
      return dateService.isSameDate(date, specialDate);
    });
  };

  return {
    getIsSpecialDate,
  };
}
